import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { DarkModeProvider } from './contexts/DarkModeContext';
import { ServerStatusProvider } from './contexts/ServerStatusContext';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminLogin from './pages/AdminLogin';
import UserPanel from './pages/UserPanel';
import AdminPanel from './pages/AdminPanel';
import RankShop from './pages/RankShop';
import RankDetailPage from './pages/RankDetailPage';
import PageLoader from './components/PageLoader';
import Contact from './pages/Contact';
import ScrollToTop from './utils/ScrollToTop';
import PageTitle from './utils/PageTitle';
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';
import './App.css';

function App() {
    return (
        <DarkModeProvider>
            <AuthProvider>
                <ServerStatusProvider>
                    <Router>
                        <ScrollToTop />
                        <PageTitle />

                        <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
                            <Navbar />

                            <main className="flex-1">
                                {/* این AnimatePresence + Suspense جادو می‌کنه */}
                                <AnimatePresence mode="wait">
                                    <Suspense fallback={<PageLoader />}>
                                        <Routes>
                                            <Route path="/" element={<Home />} />
                                            <Route path="/login" element={<Login />} />
                                            <Route path="/register" element={<Register />} />
                                            <Route path="/admin-login" element={<AdminLogin />} />
                                            <Route path="/ranks" element={<RankShop />} />
                                            <Route path="/ranks/:rankType" element={<RankDetailPage />} />
                                            <Route path="/contact" element={<Contact />} />
                                            <Route path="/forgot-password" element={<ForgotPassword />} />

                                            <Route
                                                path="/user-panel"
                                                element={
                                                    <ProtectedRoute>
                                                        <UserPanel />
                                                    </ProtectedRoute>
                                                }
                                            />
                                            <Route
                                                path="/admin-panel"
                                                element={
                                                    <ProtectedRoute adminOnly>
                                                        <AdminPanel />
                                                    </ProtectedRoute>
                                                }
                                            />
                                            <Route
                                                path="/tickets"
                                                element={
                                                    <ProtectedRoute>
                                                        <Tickets />
                                                    </ProtectedRoute>
                                                }
                                            />
                                            <Route
                                                path="/tickets/:id"
                                                element={
                                                    <ProtectedRoute>
                                                        <TicketDetail />
                                                    </ProtectedRoute>
                                                }
                                            />
                                        </Routes>
                                    </Suspense>
                                </AnimatePresence>
                            </main>

                            <Footer />

                            <Toaster position="top-center" />
                        </div>
                    </Router>
                </ServerStatusProvider>
            </AuthProvider>
        </DarkModeProvider>
    );
}
export default App;
